import React, {useEffect, useState} from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { useTranslation } from "react-i18next";
import { SearchPanel, TableCustom } from "../../components";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getServiceExpenses, addServiceExpense, editServiceExpense, deleteServiceExpense, getServiceExpenseByKey } from "../../redux/actions/serviceExpenseActions";
import CreateServiceExpense from "./Popups/CreateServiceExpense";
import ServiceExpenseDetails from "./Popups/ServiceExpenseDetails";
import EditServiceExpense from "./Popups/EditServiceExpense";
import RemoveServiceExpense from "./Popups/RemoveServiceExpense";

function createData(id, name, summary, service, reagent) {
    return {id, name, summary, service, reagent};
}

let rows = [
    createData(1, "abc", 1.0, null, null),
];
const ServiceExpenseList = () => {
    const {t} = useTranslation();
    const rowName = [
        {text: t("serviceExpenseList.tableItem.id")},
        {text: t("serviceExpenseList.tableItem.name")},
        {text: t("serviceExpenseList.tableItem.summary")},
        {text: t("serviceExpenseList.tableItem.service")},
        {text: t("serviceExpenseList.tableItem.reagent")},
        {text: t("serviceExpenseList.tableItem.actions")},
    ];
    const dispatch = useDispatch();

    const [query, setQuery] = useState({ "sort": { "id": { "operator": "asc" } } });

    const [id, setId] = useState(null);
    const [createOpen, setCreateOpen] = useState(false);
    const setCreateHandler = async () => {
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setCreateOpen(true);
        setId(null);
    }
    const createSubmit = async (_) => {
        await dispatch(addServiceExpense(_, query));
    }
    const [detailsOpen, setDetailsOpen] = useState(false);
    const setDetailsHandler = async (id) => {
        await dispatch(getServiceExpenseByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setDetailsOpen(true);
        setId(id);
    }
    
    const [editOpen, setEditOpen] = useState(false);
    const setEditHandler = async (id) => {
        await dispatch(getServiceExpenseByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setEditOpen(true);
        setId(id);
    }
    const editSubmit = async (_) => {
        await dispatch(editServiceExpense(_, query));
    }
    const [removeOpen, setRemoveOpen] = useState(false);
    const setRemoveHandler = async (id) => {
        await dispatch(getServiceExpenseByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setRemoveOpen(true);
        setId(id);
    }
    const removeSubmit = async (_) => {
        await dispatch(deleteServiceExpense(_.id, query));
    }

    const localData = false;
    const state = useSelector((state) => state.serviceExpense);
    if (!localData && state.serviceExpenses)
    {
        rows = state.serviceExpenses;
    }
    useEffect(() => {
        if (!localData)
        {
            dispatch(getServiceExpenses(query));
        }
    }, [dispatch]);
    return (
        <DashboardLayout>
            <Box sx={{margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <SearchPanel searchName="id" search={rows} label={t("serviceExpenseList.searchLabel")}/>
                <Button color="primary" variant="contained" onClick={() => setCreateHandler()}>
                    {t("serviceExpenseList.createText")}
                </Button>
            </Box>
            <TableCustom avatars={false} rowName={rowName} rows={rows.map(_ => {
                return {
                    id: _.id,
                    name: _.name,
                    summary: _.summary,
                    service: _.service?.name,
                    reagent: _.reagent?.name,
                }
            })} actions={(_) => [<VisibilityIcon onClick={() => setDetailsHandler(_.id)}/>,<EditIcon onClick={() => setEditHandler(_.id)}/>,<DeleteForeverIcon onClick={() => setRemoveHandler(_.id)}/>]}/>
            <CreateServiceExpense action={'create'} title={t("serviceExpenseList.createText")} open={createOpen} setOpen={setCreateOpen} onSubmit={createSubmit}/>
            <ServiceExpenseDetails action={'details'} title={t("serviceExpenseList.detailsText")} open={detailsOpen} setOpen={setDetailsOpen} />
            <EditServiceExpense action={'edit'} title={t("serviceExpenseList.editText")} open={editOpen} setOpen={setEditOpen} onSubmit={editSubmit}/>
            <RemoveServiceExpense action={'remove'} title={t("serviceExpenseList.removeText")} open={removeOpen} setOpen={setRemoveOpen} onSubmit={removeSubmit}/>
        </DashboardLayout>
    )
};

export default ServiceExpenseList;
